var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCityBuilding = function SvgCityBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.467 62.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "city-building_svg__a",
    width: 65.467,
    height: 62.5,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.453 22.646h2a.742.742 0 0 0 0-1.483h-2a.7.7 0 0 0-.742.742.743.743 0 0 0 .742.741",
    "data-name": "Path 281"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.535 22.646h2a.742.742 0 0 0 0-1.483h-2a.742.742 0 1 0 0 1.483",
    "data-name": "Path 282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.453 26.726h2a.742.742 0 1 0 0-1.483h-2a.7.7 0 0 0-.742.742.743.743 0 0 0 .742.741",
    "data-name": "Path 283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.535 26.726h2a.742.742 0 0 0 0-1.483h-2a.742.742 0 1 0 0 1.483",
    "data-name": "Path 284"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.453 30.731h2a.742.742 0 1 0 0-1.483h-2a.7.7 0 0 0-.742.742.743.743 0 0 0 .742.741",
    "data-name": "Path 285"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.535 30.731h2a.742.742 0 0 0 0-1.483h-2a.742.742 0 1 0 0 1.483",
    "data-name": "Path 286"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.453 34.068h2a.742.742 0 1 0 0-1.483h-2a.7.7 0 0 0-.742.742.743.743 0 0 0 .742.741",
    "data-name": "Path 287"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.535 34.068h2a.742.742 0 0 0 0-1.483h-2a.742.742 0 1 0 0 1.483",
    "data-name": "Path 288"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.453 38.147h2a.742.742 0 1 0 0-1.483h-2a.7.7 0 0 0-.742.742.743.743 0 0 0 .742.741",
    "data-name": "Path 289"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.535 38.147h2a.742.742 0 0 0 0-1.483h-2a.742.742 0 1 0 0 1.483",
    "data-name": "Path 290"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.453 42.152h2a.742.742 0 1 0 0-1.483h-2a.7.7 0 0 0-.742.742.743.743 0 0 0 .742.741",
    "data-name": "Path 291"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.535 42.152h2a.742.742 0 1 0 0-1.483h-2a.742.742 0 1 0 0 1.483",
    "data-name": "Path 292"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.77 32.066h4.153a.742.742 0 1 0 0-1.483H31.77a.742.742 0 0 0 0 1.483",
    "data-name": "Path 293"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.77 37.257h4.153a.742.742 0 1 0 0-1.483H31.77a.742.742 0 1 0 0 1.483",
    "data-name": "Path 294"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.77 42.375h4.153a.742.742 0 1 0 0-1.483H31.77a.742.742 0 1 0 0 1.483",
    "data-name": "Path 295"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.77 47.566h4.153a.742.742 0 1 0 0-1.483H31.77a.742.742 0 1 0 0 1.483",
    "data-name": "Path 296"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.866 48.753a.7.7 0 0 0 .742-.742V29.767a.742.742 0 1 0-1.483 0v18.319a.73.73 0 0 0 .741.667",
    "data-name": "Path 297"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.155 48.753a.7.7 0 0 0 .742-.742V26.726a.742.742 0 1 0-1.483 0v21.358a.73.73 0 0 0 .741.669",
    "data-name": "Path 298"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#city-building_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.725 52.017h-.742V25.836a.45.45 0 0 0 .3.074.78.78 0 0 0 .667-.371.655.655 0 0 0-.3-.964c-6.378-3.263-9.642-4.969-11.2-5.711a.073.073 0 0 1-.074-.074c0-.074-.074 0-.074-.074a4.4 4.4 0 0 0-.593-.3c.074.074.222.074.3.148-.148-.074-.222-.074-.3-.148h-.148c-.074 0-.074 0-.074-.074h-.148c-.074 0-.074-.074-.074 0-.816-.445-2.077-1.038-4-2a.655.655 0 0 0-.964.3.655.655 0 0 0 .3.964l.519.222v6.6L28.654 26.8v-9.048a.7.7 0 0 0-.742-.742h-2.744v-1.854a2.23 2.23 0 0 0-2.225-2.225h-2.966V9.742a.742.742 0 1 0-1.483 0v3.189h-2.967a2.23 2.23 0 0 0-2.227 2.225v1.854h-2.149a.7.7 0 0 0-.742.742v34.265h-.667a.742.742 0 0 0 0 1.483h45.983a.742.742 0 0 0 0-1.483M14.711 15.156a.743.743 0 0 1 .742-.742h7.417a.743.743 0 0 1 .742.742v1.854h-8.9Zm6.527 36.861h-3.412v-5.563h3.412Zm5.859 0h-4.376v-6.3a.7.7 0 0 0-.742-.742h-4.9a.7.7 0 0 0-.742.742v6.3h-4.444V18.493H27.1Zm11.941 0H28.58V28.135l10.458-2.373Zm14.462 0H40.521v-33.6L53.5 25.094Z",
    "data-name": "Path 299"
  }))));
};
export default SvgCityBuilding;